export default () => ({ serviceWorkerRegistered: true });



// WEBPACK FOOTER //
// ./datastore/actions/set-service-worker-registered.js